export const getCachedImageUrl = (documentId, imageId) => {
    const cachedUrl = sessionStorage.getItem(`${documentId}-${imageId}`);
    if (cachedUrl) {
        const cachedUrlData = JSON.parse(cachedUrl);
        // if old style cache without expiration or item expired, clear item from sessionStorage
        if (!cachedUrlData.expiration || new Date().toISOString() > cachedUrlData.expiration) {
            sessionStorage.removeItem(`${documentId}-${imageId}`);
            return null;
        }
        return cachedUrlData;
    }
    return null;
};

export const setCachedImageUrl = (documentId, imageId, url) => {
    sessionStorage.setItem(`${documentId}-${imageId}`, JSON.stringify(url));
};
